import React, {Component} from 'react';
import {translate} from 'react-i18next';
import TinyMCE from 'react-tinymce';

class AddEditDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            key: '',
            de: '',
            en: '',
            translationId: false,
            translationType: 'SHORT'
        };

        this.handleCancelAddEditTranslation = this.handleCancelAddEditTranslation.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleEditorChangeDe = this.handleEditorChangeDe.bind(this);
        this.handleEditorChangeEn = this.handleEditorChangeEn.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleEditorChangeDe(e) {
        this.setState({
            de: e.target.getContent()
        });
    }

    handleEditorChangeEn(e) {
        this.setState({
            en: e.target.getContent()
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if (!this.props.addEditDialog.loading) {
            this.props.submitAddEditTranslation(this.state.translationId, this.state.key, this.state.de, this.state.en, this.state.translationType);
        }
    }

    handleCancelAddEditTranslation() {
        this.props.cancelAddEditTranslations();
    }

    componentWillMount() {
        this.setState({
            translationId: this.props.addEditDialog.translationId,
            key: this.props.addEditDialog.key,
            de: this.props.addEditDialog.strings.de,
            en: this.props.addEditDialog.strings.en,
            translationType: this.props.addEditDialog.translationType
        })
    }

    render() {
        const {addEditDialog, t} = this.props;
        return (
            <div className="AddEditDialog modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button className="close" onClick={this.handleCancelAddEditTranslation}>
                                <span>x</span>
                            </button>
                            <h4 className="modal-title">
                                {t('translation.addEditDialog.title.' + (addEditDialog.translationId ? 'edit' : 'add'))}
                            </h4>
                        </div>
                        <form onSubmit={this.handleFormSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div
                                            className={"form-group" + ((addEditDialog.errors && addEditDialog.errors.key) ? ' has-error' : '')}>
                                            <label>{t('translation.addEditDialog.key.label')}</label>
                                            <input className="form-control" type="text" name="key" value={this.state.key}
                                                   onChange={this.handleInputChange}/>
                                            {(addEditDialog.errors && addEditDialog.errors.key) ? (
                                                <span className="help-block">
                                            {t('translation.addEditDialog.key.error.' + addEditDialog.errors.key)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>{t('translation.addEditDialog.translationType.label')}</label>
                                            <select className="form-control" name="translationType"
                                                    value={this.state.translationType}
                                                    onChange={this.handleInputChange}>
                                                <option value="SHORT" key="SHORT">
                                                    {t('default.translationType.SHORT')}
                                                </option>
                                                <option value="LONG" key="LONG">
                                                    {t('default.translationType.LONG')}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="hr-line-dashed"/>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div
                                            className={"form-group" + ((addEditDialog.errors && addEditDialog.errors.de) ? ' has-error' : '')}>
                                            <label>{t('translation.addEditDialog.de.label')}</label>
                                            {this.state.translationType === 'LONG' ? (
                                                <TinyMCE
                                                    content={this.state.de}
                                                    config={{
                                                        menubar: false,
                                                        plugins: 'autolink link image lists code',
                                                        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link unlink image | formatselect forecolor | code'
                                                    }}
                                                    onChange={this.handleEditorChangeDe}
                                                />
                                            ) : (
                                                <input className="form-control" type="text" name="de" value={this.state.de}
                                                       onChange={this.handleInputChange}/>
                                            )}

                                            {(addEditDialog.errors && addEditDialog.errors.de) ? (
                                                <span className="help-block">
                                            {t('translation.addEditDialog.de.error.' + addEditDialog.errors.de)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div
                                            className={"form-group" + ((addEditDialog.errors && addEditDialog.errors.en) ? ' has-error' : '')}>
                                            <label>{t('translation.addEditDialog.en.label')}</label>
                                            {this.state.translationType === 'LONG' ? (
                                                <TinyMCE
                                                    content={this.state.en}
                                                    config={{
                                                        menubar: false,
                                                        plugins: 'autolink link image lists',
                                                        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link unlink image | formatselect forecolor | code'
                                                    }}
                                                    onChange={this.handleEditorChangeEn}
                                                />
                                            ) : (
                                                <input className="form-control" type="text" name="en" value={this.state.en}
                                                       onChange={this.handleInputChange}/>
                                            )}

                                            {(addEditDialog.errors && addEditDialog.errors.en) ? (
                                                <span className="help-block">
                                            {t('translation.addEditDialog.en.error.' + addEditDialog.errors.en)}
                                        </span>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default" onClick={this.handleCancelAddEditTranslation}>
                                    {t('default.cancel')}
                                </button>
                                <button className="btn btn-primary" type="submit" disabled={addEditDialog.loading}>
                                    {addEditDialog.loading ? (
                                        <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                    ) : null}
                                    {t('translation.addEditDialog.submit')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(AddEditDialog);